import { render, staticRenderFns } from "./Declaration_nurse.vue?vue&type=template&id=5235120e&scoped=true"
import script from "./Declaration_nurse.vue?vue&type=script&lang=js"
export * from "./Declaration_nurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235120e",
  null
  
)

export default component.exports